import React, { Fragment } from "react";
import styled from "styled-components";
import _ from "lodash";
import { connect } from "react-redux";
import { compose } from "redux";
import queryString from "query-string";
import { Tabs, Tab, AppBar, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import SecondaryButton from "components/Global/Buttons/SecondaryButton";
import { downloadPrincipalTemplate } from "store/state/cashflows";

const DownloadPrincipalTemplate = props => (
  <SecondaryButton onClick={() => props.downloadPrincipalTemplate({ loanId: props.loanId })}>Principal Template</SecondaryButton>
);

export default connect(null, {
  downloadPrincipalTemplate
})
(DownloadPrincipalTemplate);
